import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { numDifferentiation, titleCase, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
import { ENV, s3_bucket_prod_url, s3_bucket_uat_url, SUB_DIRECTORY } from "../../../../common/constant";
import Blog from "../../../../component/blog";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import SocialMedia from "../../../../component/social_media";
import { actionGetClaim, resetGetClaimResponse } from "../claim/store";
import { actionDownloadPolicy, actionGetPolicyDashboard, actionGetPolicyInactive, actionNonHealthClaim, resetDownloadPolicyResponse, resetGetPolicyInactiveResponse, resetGetPolicyResponse, resetNonHealthClaimResponse } from "./store";
import _ from 'lodash';
import { useRef } from "react";
import { actionAllContactPerson, actionClientDetails, actionClientList, resetClientDetailsResponse, resetClientListResponse, resetContactPersonResponse } from "../my_profile/store";
import Loader from "../../../../component/page_loader";
import Contact from "../../../../component/contact";
import CustomerFeedback from "../../../../component/customer_feedback";
import InfromationCard from "../../../../component/information_card";
import { actionGetAppointments, resetGetAppointmentsResponse } from "../appointments/store";
import { actionReviews, resetReviewsResponse } from "../reviews/store";
import $ from 'jquery';
import { UAT, PROD } from "../../../../common/constant";

const Dashboard = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()


    const { getPolicy, downloadPolicy, nonHelthClaim, loadingGetPolicy, loadingGetPolicyInactive, loadingNonHelthClaim } = useSelector((state) => ({
        ...state.dashboardStore
    }))
    const { contactPerson, loadingContactPerson, clientList, clientDetails } = useSelector((state) => ({
        ...state.MyProfileStore
    }))
    const { getClaim, loadingGetClaim } = useSelector((state) => ({
        ...state.claimStore
    }))
    const { getAppointments } = useSelector((state) => ({
        ...state.appointmentsStore
    }))

    const { reviewsList } = useSelector((state) => ({
        ...state.reviewsStore
    }))


    const {
        register,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        watch
    } = useForm({
        defaultValues: {
            getAllPolicy: [],

        },
    });

    const getAllPolicy = watch('getAllPolicy')
    const [claim, setClaim] = useState([])
    const [clicked, setClicked] = useState("0");
    const contentEl = useRef();

    const [clickednonhealth, setClickedNonHealthClaim] = useState("0");
    const contentElNonHealthClaim = useRef();

    const [nonHealthClaim, setNonHealthClaim] = useState([])

    const [contactPersonArr, setContactPersonArr] = useState([])
    const [isCustomerFeedback, setIsCustomerFeedback] = useState(false)
    const [appointments, setAppointments] = useState([])
    const [clientObj, setClientObj] = useState(null)
    const [reviewsArr, setReviewsArr] = useState([])
    const [activePolicyCount, setActivePolicyCount] = useState([])
    const [isLoader, setIsLoader] = useState(true)

    const initialRender = () => {

        dispatch(actionGetPolicyDashboard({ department_name: "all" }))
        dispatch(actionGetClaim({ department_name: "all" }))
        dispatch(actionNonHealthClaim())
        dispatch(actionAllContactPerson())
        dispatch(actionClientList())
        dispatch(actionGetAppointments())
        dispatch(actionReviews())
        $(`<script src=${ENV === 'development' ? UAT + 'assets/js/twitterwidget.js' : PROD + '/assets/js/twitterwidget.js'}></script>`).appendTo(document.body);

    }

    useEffect(initialRender, []);


    useEffect(() => {
        if (getAppointments !== null) {
            dispatch(resetGetAppointmentsResponse())
            if (getAppointments.result === true) {
                var today = moment().format('YYYY-MM-DD')
                var upcomingAppointments = []

                getAppointments.response.map((item, index) => {
                    if (moment(item.start_date_time).format('YYYY-MM-DD') >= today) {
                        upcomingAppointments.push(
                            item
                        )
                    }
                })
                setAppointments(upcomingAppointments)

            } else {
                switch (getAppointments.status_code) {
                    case 401:
                        toast.error(getAppointments.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getAppointments])

    useEffect(() => {
        // alert(JSON.stringify(getPolicy))
        if (getPolicy !== null) {
            dispatch(resetGetPolicyResponse())
            if (getPolicy.result === true) {
                setValue('getAllPolicy', getPolicy.response)
                var today = moment().format('YYYY-MM-DD')
                var policyActiveArr = []
                var policyInActiveArr = []

                getPolicy.response.map((item, index) => {
                    if (item.policy_expiry_date >= today) {
                        policyActiveArr.push(
                            item
                        )
                    }
                    else {
                        policyInActiveArr.push(
                            item
                        )
                    }
                })
                setActivePolicyCount(policyActiveArr)
                setIsLoader(false)
            } else {
                setIsLoader(false)
                switch (getPolicy.status_code) {
                    case 401:
                        toast.error(getPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getPolicy])


    useEffect(() => {
        if (getClaim !== null) {
            dispatch(resetGetClaimResponse())
            if (getClaim.result === true) {
                setClaim(getClaim.response)
            } else {
                switch (getClaim.status_code) {
                    case 401:
                        toast.error(getClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getClaim])

    useEffect(() => {
        if (downloadPolicy !== null) {
            dispatch(resetDownloadPolicyResponse())
            if (downloadPolicy.result === true) {
                window.open(downloadPolicy.response.policy_url, '_blank')
            } else {
                switch (downloadPolicy.status_code) {
                    case 401:
                        toast.error(downloadPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [downloadPolicy])

    useEffect(() => {
        if (nonHelthClaim !== null) {
            dispatch(resetNonHealthClaimResponse())
            if (nonHelthClaim.result === true) {
                setNonHealthClaim(nonHelthClaim.response)
                setIsLoader(false)
            } else {
                setIsLoader(false)
                switch (nonHelthClaim.status_code) {
                    case 401:
                        toast.error(nonHelthClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [nonHelthClaim])

    useEffect(() => {
        if (contactPerson !== null) {
            dispatch(resetContactPersonResponse())
            if (contactPerson.result === true) {
                setContactPersonArr(contactPerson.response)
            } else {
                switch (contactPerson.status_code) {
                    case 401:
                        toast.error(contactPerson.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [contactPerson])

    useEffect(() => {
        if (clientList !== null) {
            dispatch(resetClientListResponse())
            if (clientList.result === true) {
                dispatch(actionClientDetails({ client_id: clientList.response[0].id }))
            } else {
                switch (clientList.status_code) {
                    case 401:
                        toast.error(clientList.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [clientList])

    useEffect(() => {
        if (reviewsList !== null) {
            dispatch(resetReviewsResponse())
            if (reviewsList.result === true) {
                setReviewsArr(reviewsList.data.reviews)
            } else {
                switch (reviewsList.status_code) {
                    case 401:
                        toast.error(reviewsList.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [reviewsList])

    useEffect(() => {
        if (clientDetails !== null) {
            dispatch(resetClientDetailsResponse())
            if (clientDetails.result === true) {
                setClientObj(clientDetails.response)
            } else {
                switch (clientDetails.status_code) {
                    case 401:
                        toast.error(clientDetails.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [clientDetails])

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked("0");
        }
        setClicked(index);
    };

    const handleToggleNonHealrhClaim = (index) => {
        if (clickednonhealth === index) {
            return setClickedNonHealthClaim("0");
        }
        setClickedNonHealthClaim(index);
    };

    const renderProgressBar = (item) => {

        var date1 = moment(new Date()).format("YYYY-MM-DD");
        var date2 = moment(item?.policy_expiry_date);
        var days = date2.diff(date1, 'days')

        return (
            <>
                <p class="fw-600 mb-0">{days} Days left</p>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style={{ width: `${days}%` }} aria-valuenow="135"
                        aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </>
        )
    }

    const renderDocuments = (item) => {
        var arrDoc = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrDoc.push(
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body d-flex justify-content-between">
                                <div className="col-10">
                                    <p className="mb-0">{item.actual_uploaded_file_name}</p>
                                    <small>{moment(item.created_at).format('DD/MM/YYYY')}</small>
                                </div>
                                <div className="col-2 text-center">
                                    <i className="fa fa-download cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            dispatch(actionDownloadPolicy({ dms_id: item.dms_id }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrDoc.push(
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            No Documents Uploaded
                        </div>
                    </div>
                </div>
            )

        return arrDoc

    }

    const renderEndorsement = (item) => {
        var arrEndorsement = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrEndorsement.push(
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <a class=" w-100" data-bs-toggle="collapse" href="#collapseExample"
                                    role="button" aria-expanded="false" aria-controls="collapseExample">
                                    <div class="d-flex">
                                        {/* <div class="col-1 text-center my-auto">
                                            <i class="fa fa-download "></i>
                                        </div> */}
                                        <div class="col-10">
                                            <p className="mb-0">{item.policy_type}</p>
                                            <small>Endorsement NO. : {item.endo_no}</small>
                                        </div>
                                    </div>
                                </a>
                                <div class="collapse" id="collapseExample">
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Policy Type :</label>
                                            <p class="card-value mb-0">{item.policy_type}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Insure Company</label>
                                            <p class="card-value mb-0"> {item.insurer_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Endorsement Executive</label>
                                            <p class="card-value mb-0"> {item.csc_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">RM Name</label>
                                            <p class="card-value mb-0">{item.rm_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Status</label>
                                            <p class="card-value mb-0">{item.status}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Department</label>
                                            <p class="card-value mb-0"> {item.department}</p>
                                        </div>
                                    </div>
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-md-4 fw-bold border-end">Net Premium: <span>{numDifferentiation(item.net_premium)}</span></div>
                                        <div class="col-md-4 fw-bold border-end">GST: <span>{numDifferentiation(item.service_tax)}</span></div>
                                        <div class="col-md-4 fw-bold ">Total Premium: <span>{numDifferentiation(item.gross_premium)}</span></div>
                                    </div>
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-md-6 fw-bold border-end">Created On: <span>{moment(item.created_at).format('DD/MM/YYYY')}</span></div>
                                        <div class="col-md-6 fw-bold border-end">Modified On:  <span>{moment(item.updated_at).format('DD/MM/YYYY')}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrEndorsement.push(
                <></>
            )

        return arrEndorsement

    }

    const renderPolicy = () => {
        var policyArr = []

        activePolicyCount != null && activePolicyCount.length > 0 ?
            activePolicyCount.map((item, index) => {
                if (index <= 2) {
                    policyArr.push(
                        <div className="accordion">
                            <div className="col-12 mt-3 position-relative">
                                <div className="card border-0 policy-card">
                                    <div className="card-header d-flex" onClick={() => {
                                        handleToggle(index)
                                    }}>
                                        <div>
                                            <img
                                                src={`${ENV === 'development' ? s3_bucket_uat_url : s3_bucket_prod_url}projects/pinc_network/resources/insurance_products_icons/ic_default.png`}
                                                className="card-icon ms-auto"
                                                alt=""
                                            />
                                            <span className="ms-auto fw-600 card-title">{item.policy_type_name}</span>
                                        </div>
                                        {/* <span class="badge rounded-pill bg-primary ms-auto lh-base">View Quote</span> */}
                                    </div>
                                    <div className="card-body pointer">
                                        <div className="row">
                                            <div class="col-12">
                                                <label class="card-label mb-2"> <b>{titleCase(item.company_name)}</b></label>
                                            </div>
                                            <div className="col-12 col-md-2">
                                                <img
                                                    src={item.insurer_company_logo}
                                                    className="w-75"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="col-12 col-md-8">
                                                <div className="row">
                                                    <div className="col-6 mt-2 mt-md-0">
                                                        <label className="card-label">Policy No.:</label>
                                                        <p className="card-value mb-0"> {item.policy_no}</p>
                                                    </div>
                                                    <div className="col-6 mt-2 mt-md-0">
                                                        <label class="card-label">Premium:</label>
                                                        <p className="card-value mb-0">₹ {numDifferentiation(item.net_premium)} </p>
                                                    </div>
                                                    <div className="col-6 mt-2 mt-md-0">
                                                        <label className="card-label">Start Date:</label>
                                                        <p className="card-value mb-0">{moment(item.policy_start_date).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                    <div className="col-6 mt-2 mt-md-0">
                                                        <label className="card-label">End Date:</label>
                                                        <p className="card-value mb-0">{moment(item.policy_expiry_date).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-2 text-start">
                                                <label className="card-label text-primary fw-600">
                                                    Renewal Status:
                                                </label>
                                                {
                                                    item.renewal_status === 'active' ?
                                                        renderProgressBar(item)
                                                        :
                                                        <p className="fw-600 mb-0 badge bg-danger rounded">Expired</p>

                                                }
                                            </div>

                                            <div className="col-12"
                                                ref={contentEl}
                                                hidden={clicked === index ? false : true}>
                                                <div className="row mt-3 bg-light py-3 rounded fs-7 ">
                                                    <div className="col-md-6">
                                                        {/* <p className="mb-0">
                                                            <b>{item.insurer_name}</b>
                                                        </p> */}
                                                        {/* <p>
                                                            <span className="text-primary">Branch:</span> {item.insurer_branches}
                                                        </p> */}
                                                        <p className="text-dark my-auto">
                                                            Contact Person:{" "}
                                                            <b className="text-primary">{item.rm_name}</b>
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul className="list-group">
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span className="text-dark my-auto">
                                                                    Status: <b className="text-primary">{_.capitalize(item.policy_status)}</b>
                                                                </span>
                                                                <button className="btn btn-sm btn-primary fs-7"
                                                                    onClick={() => {
                                                                        navigate('/claim/intimate-claim', { state: { data: item } })
                                                                    }}
                                                                >
                                                                    Intimate Claim
                                                                </button>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between bg-light">
                                                                <span className="fw-bold">Sum Insured</span>{" "}
                                                                <span className="fw-bold">
                                                                    <i className="fa fa-inr" /> {numDifferentiation(item.sum_insured)}
                                                                </span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>Net Premium</span>{" "}
                                                                <span>
                                                                    <i className="fa fa-inr" />{numDifferentiation(item.net_premium)}
                                                                </span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>GST</span>{" "}
                                                                <span>
                                                                    <i className="fa fa-inr" /> {numDifferentiation(item.service_tax)}
                                                                </span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>
                                                                    <b>Gross Premium</b>
                                                                </span>
                                                                <b>
                                                                    {" "}
                                                                    <span>
                                                                        <i className="fa fa-inr" /> {numDifferentiation(item.gross_premium)}
                                                                    </span>
                                                                </b>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-12 mt-3 mt-md-0">
                                                        <h6>Documents({item.documents.length})</h6>
                                                    </div>
                                                    {renderDocuments(item.documents)}
                                                    <div class="col-12 mt-3">
                                                        <h6>Endorsement</h6>
                                                    </div>
                                                    {renderEndorsement(item.endorsements)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img alt="ribbon" className="ribbon" src={`${SUB_DIRECTORY}/assets/images/ribbon.png`} />
                            </div>
                        </div>

                    )
                }
            })
            :
            policyArr.push(
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <h5>No Active Policies To Display</h5>
                </div>
            )
        return policyArr
    }

    const renderNonHealthClaim = () => {
        var nonHealthClaimArr = []
        nonHealthClaim != null && nonHealthClaim.length > 0 ?
            nonHealthClaim.map((item, index) => {
                if (index <= 2) {
                    nonHealthClaimArr.push(
                        <div className="col-md-12 mb-4 mt-3">
                            <div className="card">
                                <div className="card-body">
                                    <div className="accordion">
                                        <div className="row" onClick={() => {
                                            handleToggleNonHealrhClaim(index)
                                        }} style={{ cursor: 'pointer' }}>
                                            <div className="col-1 text-center my-auto">
                                                <img
                                                    src={`${SUB_DIRECTORY}/assets/images/claim.png`}
                                                    className="w-50"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="col-11 col-md-5">
                                                <p className="mb-0 fw-600">{_.capitalize(item.client_name)}</p>
                                                <small>Policy NO. : {item.policy_no}</small>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2 mt-md-0">
                                                <p className="mb-0">Claim Amount</p>
                                                <p className="mb-0 fw-bold">₹ {numDifferentiation(item.amount)}</p>
                                            </div>
                                            <div className="col-6 col-md-2 text-center mt-2 mt-md-0">
                                                <span className="badge bg-primary rounded-pill">{_.capitalize(item.status)}</span>
                                            </div>
                                        </div>

                                        <div className="row border-top pt-2 mt-1" ref={contentElNonHealthClaim}
                                            hidden={clickednonhealth === index ? false : true}>
                                            <div className="col-12 col-md-4 mt-2">
                                                <label className="card-label">Policy Type :</label>
                                                <p className="card-value mb-0">
                                                    {" "}{item.Policytype}
                                                </p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Intimation Date :</label>
                                                <p className="card-value mb-0">{moment(item.intimate_date).format('DD/MM/YYYY')}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label text-primary">
                                                    Pinc Ref. No :{" "}
                                                </label>
                                                <p className="card-value mb-0">{item.pinc_claim_ref_no}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Date of Loss</label>
                                                <p className="card-value mb-0">{moment(item.date_of_loss).format('DD/MM/YYYY')}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Insurer</label>
                                                <p className="card-value mb-0">{item.insurer}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Nature of Claim</label>
                                                <p className="card-value mb-0">{item.nature_of_claim}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">RM Name</label>
                                                <p className="card-value mb-0">{item.rm_name}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Claim Executive</label>
                                                <p className="card-value mb-0">{item.claim_csc_name}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Department</label>
                                                <p className="card-value mb-0">{item.department}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Claim Description</label>
                                                <p className="card-value mb-0">
                                                    {item.loss_details}
                                                </p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Loss Location</label>
                                                <p className="card-value mb-0">{item.loss_location}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Claim Type</label>
                                                <p className="card-value mb-0">{item.claim_type}</p>
                                            </div>
                                            <div className="col-6 col-md-4 mt-2">
                                                <label className="card-label">Surveyor Name</label>
                                                <p className="card-value mb-0">{item.surveyor_name}</p>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <h6>Documents({item.documents.length})</h6>
                                            </div>
                                            {renderDocuments(item.documents)}
                                        </div>
                                        <div className="row border-top pt-2 mt-1 fs-7">
                                            <div className="col-md-6 fw-bold border-end">
                                                Created On: <span>{moment(item?.created_at).format('DD/MM/YYYY')}</span>
                                            </div>
                                            <div className="col-md-6 fw-bold border-end">
                                                Modified On: <span>{moment(item?.updated_at).format('DD/MM/YYYY')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            })
            :
            nonHealthClaimArr.push(
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <h5>No Non Health Claims To Display</h5>
                </div>
            )
        return nonHealthClaimArr
    }
    const renderFirstletter = (item) => {
        const str = item
        const str2 = str?.charAt(0)
        return str2?.toUpperCase()
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav
                        aria-label="breadcrumb"
                    >
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Dashboard</li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12 col-md-8">
                    <div className="row">
                        <div className="col-12 col-md-3 my-auto mt-2">
                            <div className="card total_policies_div h-100 cursor-pointer"
                                onClick={() => {
                                    navigate("/policies")
                                }}
                            >
                                <div className="card-body text-center ">
                                    <h4 className="my-2 text-primary">{getAllPolicy.length}</h4>
                                    <b>Total</b> Policies
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-3 my-auto mt-2">
                            <div className="card active_policies_div cursor-pointer"
                                onClick={() => {
                                    navigate("/policies")
                                }}
                            >
                                <div className="card-body text-center ">
                                    <h4 className="my-2 text-primary">{activePolicyCount.length}</h4>
                                    <b>Active</b> Policies
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-3 my-auto mt-2">
                            <div className="card active_policies_div cursor-pointer"
                                onClick={() => {
                                    navigate("/claim")
                                }}
                            >
                                <div className="card-body text-center">
                                    <h4 className="my-2 text-primary">{claim.length}</h4>
                                    <b>Total</b> Claims
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 my-auto mt-2">
                            <div class="card active_policies_div cursor-pointer"
                                onClick={() => {
                                    navigate("/appointments")
                                }}
                            >
                                <div class="card-body text-center ">
                                    <h4 class="my-2 text-primary">{appointments?.length}</h4>
                                    <b>Upcoming</b> Appt.
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <div>
                                <div className="mt-4 d-flex justify-content-between">
                                    <a className="btn btn-light btn-sm mx-2 fw-bold my-auto">
                                        Active Policies ({`${activePolicyCount.length}`})
                                    </a>
                                    <a className="btn btn-sm btn-warning my-auto"
                                        onClick={() => {
                                            navigate("/policies")
                                        }}
                                    >
                                        View All
                                    </a>
                                </div>
                                <div className="row">
                                    {renderPolicy()}
                                </div>
                                <div className="mt-5 d-flex justify-content-between">
                                    <a className="btn btn-light btn-sm mx-2 fw-bold my-auto">
                                        Non Health Claims ({nonHealthClaim.length})
                                    </a>
                                    <a className="btn btn-sm btn-warning my-auto"
                                        onClick={() => {
                                            navigate("/claim/non-health-claims")
                                        }}
                                    >
                                        View All
                                    </a>
                                </div>
                                <div className="row">
                                    {renderNonHealthClaim()}
                                </div>
                            </div>
                    }
                </div>
                <div className="col-12 col-md-4">
                    <div class="mb-3">
                        <div class="card profile-section">
                            <div class="card-body d-flex">
                                <div class="profile-container col-3">
                                    <div class="initial-text">
                                        <span>{renderFirstletter(clientObj != null ? clientObj?.group_name : '')}</span>
                                    </div>
                                </div>
                                <div class="ms-3 my-auto col-9">
                                    <h5 class="mb-1">{clientObj != null ? titleCase(clientObj?.group_name) : ''}</h5>
                                    {/* <p class="mb-0">Designation</p> */}
                                    <a class="small" onClick={() => {
                                        navigate("/my-profile")
                                    }}>View Profile</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Contact contactPersonArr={contactPersonArr} />
                    <RecommendedPolicy />
                    <InfromationCard isMarginTop={true} />
                    <Newsletter />
                    <div class="mt-3">
                        <span class="fw-bold">Feedback</span>
                        <div class="card mt-2 shadow p-2 d-flex cursor-pointer" data-bs-toggle="modal" data-bs-target="#customerfeedback">
                            <div onClick={() => {
                                setIsCustomerFeedback(true)
                            }}>
                                <img src={`${SUB_DIRECTORY}/assets/images/icon/megaphone.png`} className="img-fluid me-3" /> <b>Customer feedback</b>
                            </div>
                        </div>
                    </div>
                    <Blog />
                    {/* <OurApp /> */}
                    {/* <SocialMedia /> */}
                    <div className="mt-3">
                        <span className="fw-bold">Social Medias</span>
                        <div className="card mt-3 shadow">
                            <div className="card-body">
                                <a className="twitter-timeline"
                                    data-width="500"
                                    data-height="400"
                                    href="https://twitter.com/PINCInsurance?ref_src=twsrc%5Etfw"
                                >Tweets by PincInsure</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div class="bg-light mb-5 py-4">
                    <div class=" container">
                        <div class=" row">

                            <div class="d-flex mb-3 pb-2 border-bottom">
                                <h4 class="fw-bold px-0 my-auto">Reviews</h4>
                                <a onClick={() => {
                                    navigate("/reviews", { replace: true });

                                }} class="my-auto ms-auto text-primary">View All</a>
                            </div>

                            {
                                reviewsArr != null && reviewsArr.length > 0 ?
                                    reviewsArr.map((item, index) => {
                                        if (index === 0) {
                                            return (
                                                <div class=" px-5 col-md-12">
                                                    <i class="fa fa-quote-left"></i>
                                                    &nbsp;{item.content}
                                                    <i class="fa fa-quote-right"></i>
                                                    <p class="fw-bold mb-0 mt-3">-<i>{item.name}</i></p>
                                                </div>
                                            )
                                        }

                                    })
                                    :
                                    <>
                                        <h5>No Reviews To Display</h5>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <CustomerFeedback
                isCustomerFeedback={isCustomerFeedback}
                feedbackClose={() => {
                    window.location.reload()
                    setIsCustomerFeedback(false)
                }}
            />
        </>

    )

}

export default Dashboard;